import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Avatar, Table } from 'antd'
import axios from 'axios'
import { useDeepEffect } from '../../../../utils/hooks'
import { isEmpty } from 'lodash'
import PreviewImage from '../../../../components/PreviewImage'

export const HeroBin = ({ hero }) => {
  const [bins, setBins] = useState([])
  const [visiblePreview, setVisiblePreview] = useState(false)
  const [previewImage, setPreviewImage] = useState(null)

  async function fetchData() {
    try {
      setBins([])
      const res = await axios.get(
        process.env.REACT_APP_API_ENDPOINT + `/bin/heroBin/${hero.id}`
      )

      setBins((prevState) => {
        res.data.forEach((item) => {
          prevState.push(item)
        })
        return [...prevState]
      })
    } catch (err) {
      console.log(err)
    }
  }

  useDeepEffect(() => {
    fetchData()
  }, [])

  const columns = [
    {
      title: 'ภาพ',
      dataIndex: 'image',
      key: 'image',
      render: (text, record) => <Avatar src={text} alt="" size={64} />
    },
    {
      title: 'ถังอัจฉริยะ',
      dataIndex: 'name',
      key: 'name',
      align: 'center'
    },
    {
      title: 'รายการวัสดุที่รับ',
      dataIndex: 'materialDtoList',
      key: 'materialDtoList',
      align: 'center',
      render: (text) =>
        !isEmpty(text) ? (
          <span>{text.map((item) => item.name).join(',')}</span>
        ) : (
          '-'
        )
    }
  ]

  return (
    <div>
      <PreviewImage
        imgUrl={previewImage}
        visible={visiblePreview}
        onClose={() => {
          setVisiblePreview(false)
          setPreviewImage(null)
        }}
      />
      <Table
        bordered
        rowKey={(record) => record.id}
        dataSource={bins}
        columns={columns}
      />
    </div>
  )
}

HeroBin.propTypes = {
  hero: PropTypes.array.isRequired
}

export default HeroBin
